import Vue from "vue";
import VueRouter from "vue-router";
import routes from './routes';



Vue.use(VueRouter);

const Router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_ROUTE,
  routes,
});

// For Middleware
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];

  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

Router.beforeEach((to, from, next) => {
  // Middleware
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];
    const context = {
      from,
      next,
      Router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);
    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default Router;